// @ts-nocheck
import styled from 'styled-components';
import { getTheme } from 'settings/theme';
import type { StatelessFunctionalComponent } from 'react';
import { TABLET_SMALL_WIDTH } from 'commons/constants';

const {
  palette: { greyscale, noodle, blue },
  boxShadow,
  spacing,
} = getTheme();
const PaginationWrapper: StatelessFunctionalComponent<any> = styled.div`
  &&& {
    cursor: pointer;
  }
  align-items: center;
  display: flex;
  font-size: 1.4rem;
  justify-content: center;

  .pagination {
    align-items: center;
    border-radius: 0.4rem;
    background-color: ${greyscale.white};
    box-shadow: ${boxShadow.default};
    display: flex;
    justify-content: center;
    margin: 0;

    li {
      .selected {
        background-color: ${noodle.primary};
        border: 0.1rem solid ${noodle.primary};
        color: ${greyscale.white} !important;
        font-weight: bold;

        a {
          color: ${greyscale.white} !important;
        }
      }

      a {
        color: ${noodle.primary};
      }

      a:hover {
        color: ${blue.bayOfMany};
      }
    }

    @media screen and (max-width: ${TABLET_SMALL_WIDTH}px) {
      margin: 0 0 28px;
    }
  }
  a {
    align-items: center;
    border-right: 0.1rem solid ${greyscale.snow};
    display: flex;
    flex: 1;
    justify-content: center;
    outline-style: none;
    padding: 1rem 1.5rem;
  }
  .active {
    background-color: ${noodle.primary};
    border: 0.1rem solid ${noodle.primary};
    color: ${greyscale.white} !important;
    font-weight: bold;
  }
  .next a {
    border-right: 0;
  }

  @media only screen and (max-width: 536px) {
    font-size: 1.2rem;
    margin-top: ${spacing.x3};
    .pagination {
      flex: 1;
      margin-bottom: 0;
    }
    a {
      padding: 1rem 1rem;
    }
    li {
      flex: 1;
    }
  }
`;
export default PaginationWrapper;
